import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {IssueNewContent} from '@github-ui/issues-shared/IssueNewContent'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'

import {issueNewRoute} from './issue-new-route'
import {issuesLayoutRoute} from './issues-layout-route'

export function IssueNew() {
  const payload = useRouteQuery(issueNewRoute, 'mainQuery')
  const layoutPayload = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const currentUserSettings = layoutPayload.data?.currentUserSettings

  // FORBIDDEN/SAML reloads the page; other errors throw to the boundary.
  const data = handleRepositoryDataError(payload.data)
  if (!data?.repository) {
    return null
  }

  // The create form owns its own chrome, so this leaf skips RepoIssuesPageLayout.
  return (
    <BaseAnalyticsWrapper category="Repository Issue Create" appName="issues">
      <IssueNewContent
        repository={data.repository}
        currentUserSettings={
          currentUserSettings
            ? {
                preferred_emoji_skin_tone: currentUserSettings.preferredEmojiSkinTone,
                copilot_show_functionality: currentUserSettings.copilotShowFunctionality,
              }
            : undefined
        }
        duplicateDetectionEnabled={payload.data?.semantic_similarity_duplicate_issue_detection}
      />
    </BaseAnalyticsWrapper>
  )
}
